// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReadMoreButton = require("../../components/buttons/ReadMoreButton.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MyBroadcastMessagesWidgetListItem = require("./MyBroadcastMessagesWidgetListItem.bs.js");
var MyBroadcastMessagesWidgetList_query_graphql = require("../../__generated__/MyBroadcastMessagesWidgetList_query_graphql.bs.js");
var MyBroadcastMessagesWidgetListPaginationQuery_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListPaginationQuery_graphql.bs.js");

var getConnectionNodes = MyBroadcastMessagesWidgetList_query_graphql.Utils.getConnectionNodes;

var convertFragment = MyBroadcastMessagesWidgetList_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = MyBroadcastMessagesWidgetListPaginationQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = MyBroadcastMessagesWidgetListPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyBroadcastMessagesWidgetList_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

var QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                "You have not broadcast any messages.",
                JsxRuntime.jsx("br", {}),
                JsxRuntime.jsx("br", {}),
                "Want to connect with other agents on rentals, industry discussion and other topics? ",
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "/messages/new",
                      className: "hover:underline",
                      children: "Broadcast a message now"
                    })
              ]
            });
}

var MyBroadcastMessagesEmpty = {
  make: MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty
};

function MyBroadcastMessagesWidgetList(props) {
  var match = usePagination(props.query);
  var isLoadingNext = match.isLoadingNext;
  var hasNext = match.hasNext;
  var loadNext = match.loadNext;
  var data = match.data;
  var items = getConnectionNodes(data.messageBroadcastsForCurrentUser);
  var tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ReadMoreButton.make, {
                    href: "/my_broadcast_messages",
                    children: "View All"
                  }),
              className: "mt-4"
            }) : null
    ) : (
      hasNext ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        loadNext(30, undefined);
                      }),
                    disabled: isLoadingNext,
                    className: "w-full",
                    children: "See More Messages"
                  }),
              className: "mt-4"
            }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                items.length !== 0 ? JsxRuntime.jsx("div", {
                        children: items.map(function (item) {
                              var match = data.messageBroadcastsForCurrentUser;
                              return JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem.make, {
                                          message: item.fragmentRefs,
                                          listConnectionId: match !== undefined ? Caml_option.some(match.__id) : undefined
                                        }, item.nodeId);
                            }),
                        className: "flex flex-col border-b mb-6"
                      }) : JsxRuntime.jsx(MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty, {}),
                tmp,
                isLoadingNext ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Loader.make, {
                              loadingText: "Loading more messages..."
                            }),
                        className: "mt-4"
                      }) : null
              ]
            });
}

var make = MyBroadcastMessagesWidgetList;

exports.QueryFragment = QueryFragment;
exports.MyBroadcastMessagesEmpty = MyBroadcastMessagesEmpty;
exports.make = make;
/* Loader Not a pure module */
